import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const ok = localStorage.getItem("fitmama-cookie-consent");
        if (!ok) setTimeout(() => setVisible(true), 1500);
    }, []);

    if (!visible) return null;

    const accept = () => {
        localStorage.setItem("fitmama-cookie-consent", "accepted");
        setVisible(false);
    };
    const reject = () => {
        localStorage.setItem("fitmama-cookie-consent", "rejected");
        setVisible(false);
    };

    return (
        <div
            data-testid="cookie-banner"
            className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[90] bg-ink text-white p-5 md:p-6 shadow-xl border border-white/10"
        >
            <button onClick={reject} aria-label="close" className="absolute top-3 right-3 text-white/50 hover:text-white">
                <X size={16} />
            </button>
            <p className="font-serif text-lg mb-2">Cookie & Privacy</p>
            <p className="font-sans text-xs text-white/70 leading-relaxed mb-4">
                Usiamo cookie tecnici e, con il tuo consenso, cookie analitici per migliorare la tua esperienza. Leggi la nostra{" "}
                <Link to="/cookie-policy" className="underline">Cookie Policy</Link>.
            </p>
            <div className="flex gap-2">
                <button
                    onClick={accept}
                    data-testid="cookie-accept"
                    className="btn-fuchsia !py-2 !px-4 text-xs"
                >
                    Accetta tutti
                </button>
                <button
                    onClick={reject}
                    data-testid="cookie-reject"
                    className="rounded-full border border-white/30 px-4 py-2 text-xs font-sans hover:bg-white/10 transition"
                >
                    Solo essenziali
                </button>
            </div>
        </div>
    );
}
